// If the supplied number is an integer, return it as a string without decimal places.
// If it has decimal places, return it as a string with one decimal place.
export function normalizeNumber(value: number, decimalPlaces: number = 1): string {
  return Number.isInteger(value) ? value.toString() : value.toFixed(decimalPlaces);
}
